<script setup lang="ts">
import { translate } from '@/shared/i18n';
import { ProjectSettings } from '@/shared/lib';
import { Btn, Icon } from '@/shared/ui';

const { url } = defineProps<{ url: string }>();
</script>

<template>
  <a
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Btn type="primary">
      <Icon
        name="lucide:external-link"
        width="20"
        height="20"
        class="mr-2"
      />
      {{ translate('common.aboutFamilyChat', { projectName: ProjectSettings.project.name }) }}
    </Btn>
  </a>
</template>
